import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

export const careerPathService = {
  createCareerPath: async (payload) => {
    try {
      const response = await axiosInstance.post(API.careerPaths.create, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getDomains: async () => {
    try {
      const response = await axiosInstance.get(API.domains.getList);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateCareerPath: async (payload) => {
    try {
      const response = await axiosInstance.put(API.careerPaths.update, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getCareerPath: async (id) => {
    try {
      const response = await axiosInstance.get(API.careerPaths.getCareerPath(id));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createJobTitle: async (payload) => {
    try {
      const response = await axiosInstance.post(API.jobTitle.create, payload);
      return response.data;
    } catch (error) {
      console.error("Error in creating Job Title", error);
      throw error;
    }
  },

  getSkills: async (departmentId) => {
    try {
      const response = await axiosInstance.get(API.skills.getListByDept(departmentId));
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
